




















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

import countryInfoData from './iso-3166-1-info.data';

const cssPrefix = 'sw-country-icon';
const flagRatio = 32 / 44; // 0.6666667;
const horizonRatio = (48 - 4) / 48;

@Component
export default class SwCountryIcon extends SwExtendedVue {
  @Prop({ type: Number, default: 0 })
  id: number;

  @Prop({ type: String })
  isoCode: string;

  @Prop({ type: [String, Number], default: 'medium' })
  width: string | number;

  @Prop({ type: Number, default: undefined })
  height: number;

  @Prop({ type: Boolean, default: false })
  bottomAlign: boolean;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  @Prop({ type: Boolean, default: false })
  rounded: boolean;

  @Prop({ type: Boolean, default: false })
  clickable: boolean;

  cssPrefix = cssPrefix;

  get numericWidth(): number {
    if (typeof this.width === 'number') {
      return this.width;
    }
    return utilService.sizeMap[this.width] || utilService.sizeMap['medium'];
  }

  get numericHeight() {
    if (typeof this.height === 'number') {
      return this.height;
    }
    /** calculate the height based on width by using ratio */
    return this.numericWidth * flagRatio;
  }

  get rootStyle(): CSSStyleOptions {
    let width = this.numericWidth;
    let height = this.numericHeight;
    let bgSize = this.numericWidth;

    if (this.rounded) {
      width = height = Math.max(this.numericWidth, this.numericHeight);
      bgSize = height / flagRatio;
    }
    const style: CSSStyleOptions = {
      width: `${width}px`,
      height: `${height}px`,
      backgroundSize: `${bgSize / horizonRatio}px ${bgSize / horizonRatio}px`,
    };

    return style;
  }

  get useIsoCode() {
    return !!this.isoCode;
  }

  get effectiveId() {
    if (this.useIsoCode) { return this.isoCode; }
    return String(this.id);
  }

  get countryInfo() {
    let info: typeof countryInfoData[0] | undefined = undefined;
    if (this.useIsoCode) {
      info = countryInfoData[this.effectiveId];
    } else {
      info = Object.values(countryInfoData)
        .find(d => (d.myCode === this.effectiveId));
    }
    if (info) { return info; }
    info = Object.values(countryInfoData)
      .find(d => (d.myCode === '0'));
    return info!;
  }

  get countryName() {
    return this.countryInfo.name;
  }

  get title() {
    return this.countryName;
  }
}
